var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDialogIconD(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24pt",
    height: "24pt",
    viewBox: "0 0 309.000000 309.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,309.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M610 2022 l0 -607 195 -195 195 -195 0 638 0 637 211 0 c404 0 602 -56 760 -213 111 -110 171 -246 190 -432 21 -191 -12 -377 -88 -503 -85 -140 -200 -234 -354 -289 -136 -49 -243 -63 -493 -63 l-221 0 -170 -171 -170 -170 455 4 c495 4 522 7 728 72 311 98 573 346 674 635 51 147 70 356 49 539 -53 453 -349 773 -810 876 -177 40 -257 45 -713 45 l-438 0 0 -608z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487 1252 l-67 -68 0 -270 0 -270 70 -69 70 -70 203 203 202 202 -205 205 -205 205 -68 -68z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialogIconD);
export default __webpack_public_path__ + "static/media/Dialog-icon-D.0669535e88925b6f4d8d71a74a7b2e83.svg";
export { ForwardRef as ReactComponent };